<template>
  <div class="iBusiness-wrapper">
    <side-bar ref="sideBar" />
    <div :class="classObject" class="iBusiness-container">
      <top-bar />
      <div class="iBusiness-body application-body" ref="body">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from './components/slider/SideBar';
import TopBar from './components/slider/TopBar';
import Watermark from '@/utils/watermark';
export default {
  name: 'Main',
  components: {
    SideBar,
    TopBar
    // User
    // HeaderBar
  },
  data() {
    return {
      showWatermark: window.$envUtils('VUE_APP_SHOW_WATERMARK'),
      isStandalone: window.$envUtils('VUE_APP_STANDALONE')
    };
  },
  computed: {
    userAvatar() {
      // return this.$store.state.user.avatarImgPath
      return null;
    },
    unreadCount() {
      // return this.$store.state.user.unreadCount
      return 20;
    },
    classObject() {
      return {
        'side-hide': !this.$store.state.app.sidebarOpened
      };
    }
  },
  mounted() {
    this.judgeResolutionRatio();
    this.watermark();
    this.$store.state.user.authRoutes.forEach((route) => {
      if (
        route.name === 'workbench.sidebar_workorder' &&
        this.hasApp('aicc-order')
      ) {
        this.getOrderPermission();
      }
    });
  },
  // created() {
  //   // window.onload的时候，往localStorage中设置一个判断标识，供bp端判断wb是否已经打开，从而解决bp跳转wb端-页面多开问题，此处直接使用vue的created函数来代替window.onload
  //   localStorage.setItem('wbHasOpened', 'true')
  //   // 关闭页面的时候,移除该判断标识，标识wb端已关闭
  //   window.onunload = function() {
  //     localStorage.removeItem('wbHasOpened')
  //   }
  // },
  methods: {
    judgeResolutionRatio() {
      const resolutionRatio = window.screen.width;
      if (resolutionRatio <= 1366) {
        this.$refs.sideBar.foldFirMenu();
      }
    },
    getOrderPermission() {
      const roleIds = [];
      this.$store.state.user.userInfo.roles.forEach((element) => {
        roleIds.push(element.id);
      });
      const params = {
        roleIds: roleIds
      };

      this.$http
        .get(
          window.$envUtils('VUE_APP_WB_ORDER_SERVICE') +
            '/order/assignee/getPermission',
          { params }
        )
        .then((res) => {
          if (res.data.code === 2000) {
            var result = res.data.data;
            var orderPermission = {};
            result.forEach((element) => {
              if (element.name === 'assign_order_range') {
                console.log(element.value.option);
                orderPermission.assignOrderRange =
                  element.value === null ||
                  JSON.stringify(element.value) === '"{}"' ||
                  element.value === '{"option":"ALL"}'
                    ? []
                    : element.value.split(',');
              } else if (element.name === 'create_template') {
                orderPermission.createTemplate = element.value === 'true';
              } else if (element.name === 'audit_template') {
                orderPermission.auditTemplate = element.value === 'true';
              } else if (element.name === 'delete_template') {
                orderPermission.deleteTemplate = element.value === 'true';
              } else if (element.name === 'update_template') {
                orderPermission.updateTemplate = element.value === 'true';
              } else if (element.name === 'assign_order') {
                orderPermission.assignOrder = element.value === 'true';
              }
            });
            this.$store.commit('order/saveOrderPermission', orderPermission);
          }
        });
    },
    watermark() {
      if (this.showWatermark === 'true') {
        if (this.isStandalone === 'true') {
          Watermark.set(
            this.$store.state.user.loginUser.userName,
            this.$refs.body
          );
        } else {
          Watermark.set(
            localStorage.getItem('X-TENANT-ID') +
              ' -- ' +
              this.$store.state.user.loginUser.userName,
            this.$refs.body
          );
        }
      }
    },
    hasApp(val) {
      return (
        this.$store.state.user.appList &&
        this.$store.state.user.appList.length > 0 &&
        !!this.$store.state.user.appList.find((item) => item.appId === val)
      );
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/base.scss";
@import "@/assets/scss/base/_elemodify.scss";

// elementUI table表头错位问题
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
// elementUI table表头错位问题

.iBusiness-wrapper .iBusiness-body {
  position: relative;
  height: calc(100vh - 57px);
  // overflow: hidden;
}
</style>
